/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { sendEmailWithFiles } from "../../services/apiservices/email";
import moment from "moment";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import CircularProgress from "@mui/material/CircularProgress";
import { useMediaQuery } from "@mui/material";
import AuthContext from "../../hooks/authContext";
import { packageAccess } from "../../services/helpers";
import { useToast } from "../../hooks/useToast";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textArea";
import { Dialog, DialogContent, DialogTitle } from "../../components/ui/dialog";
import { ErrorDialog, StorageDialog, SuccessEmailDialog } from "./EmailDialogs";
import { FileSpreadsheet, FileText, Send } from "lucide-react";
import { Button } from "../../components/ui/button";
import { trackEvent, CMS_EVENTS } from "../../services/apiservices/analytics";

const From = "noreply@proteams.io"

function EmailReports({ open, onClose }) {
  const navigate = useNavigate();
  const [to, setTo] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [toError, setToError] = useState(false);
  const [emailData, setEmailData] = useState(null);
  const [pdfData, setPdfData] = useState(null);
  const [fullReport, setFullReport] = useState(null);
  const [fullExcelReport, setFullExcelReport] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [fileDownloadURL, setFileDownloadURL] = useState(null);
  const [pdfFileDownladUrl, setPdfFileDownloadUrl] = useState(null);
  const [fullReportUrl, setFullReportUrl] = useState(null);
  const [fullReportExcelUrl, setFullReportExcelUrl] = useState(null);
  const [attachExcel, setAttachExcel] = useState(false);
  const [attachPdf, setAttachPdf] = useState(false);
  const [attachFullPdf, setAttachFullPdf] = useState(false);
  const [attachFullExcel, setAttachFullExcel] = useState(false);
  const [pdfFileName, setPdfFileName] = useState(null);
  const [fullPdfName, setFullPdfName] = useState(null);
  const [fullExcelName, setFullExcelName] = useState(null);
  const [showFormatError, setShowFormatError] = useState(false);
  const [reportDate, setReportDate] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [openErrDialog, setOpenErrDialog] = useState(false);
  const [loader, setLoader] = useState(false);
  const [reportName, setReportName] = useState(null);
  const [name, setName] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const isMobile = useMediaQuery('(max-width:767px)');
  const isLandscape = useMediaQuery('(min-width: 771px) and (max-width: 940px)');
  const auth = useContext(AuthContext);
  const { toast } = useToast();

  const { FileName, ReportsName, Name, Date, EndDate, pdf, storedData, fullData, fullExcelData } = auth?.reportData || {};
  const companyId = auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;
  const userPackageId = auth?.userProfile?.prdId;
  const userPromocode = auth?.userProfile?.userPromoCode || auth?.userProfile?.companyData?.userPromoCode;
  const subscriptionId = auth?.userProfile?.subscriptionDetails?.scheduleId || auth?.userProfile?.subscriptions?.data?.[0]?.scheduleId;
  const allowedPermissions = packageAccess(userPackageId, userPromocode, subscriptionId);

  const Dates = (date) => {
    const weekRangePattern = /^[A-Za-z]{3} [A-Za-z]{3} \d{2}, \d{4} - [A-Za-z]{3} [A-Za-z]{3} \d{2}, \d{4}$/;

    if (weekRangePattern.test(date)) {
      return date;
    } else {
      return moment(date).format("YYYY-MM-DD");
    }
  };

  useEffect(() => {
    if (!auth?.reportData) return;

    setFileName(FileName);
    setReportDate(Dates(Date));
    setReportName(ReportsName);
    setName(Name);
    setEndDate(Dates(EndDate));

    if (pdf) setPdfData(pdf);
    if (storedData) setEmailData(storedData);
    if (fullData) setFullReport(fullData);
    if (fullExcelData) setFullExcelReport(fullExcelData);

  }, [FileName, Date, ReportsName, Name, EndDate, pdf, storedData, fullData, fullExcelData]);

  const uploadFile = (emailData, pdfData, fileName) => {
    const processFile = async (data, fileType) => {
      if (!data) {
        console.error(`Invalid ${fileType} data:`, data);
        return;
      }

      try {
        const contentTypeStart = data.indexOf(':') + 1;
        const contentTypeEnd = data.indexOf(';');
        const contentType = data.substring(contentTypeStart, contentTypeEnd);

        let Type;
        if (contentType === 'application/pdf') {
          Type = 'application/pdf';
        } else if (contentType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          Type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        } else if (contentType === 'text/csv') {
          Type = 'text/csv';
        } else {
          console.error('Unsupported file type:', contentType);
          return;
        }

        const base64DataIndex = data.indexOf('base64,') + 7;
        const base64Data = data.substring(base64DataIndex);
        const byteCharacters = atob(base64Data);
        const byteArray = new Uint8Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteArray[i] = byteCharacters.charCodeAt(i);
        }

        const blob = new Blob([byteArray], { type: Type });
        const file = new File([blob], fileName, { type: Type });
        const fileSize = file.size;
        const extraLimit = auth?.userProfile?.additionalQuantity * 5;
        const extraLimitInBytes = extraLimit * (1024 ** 3);
        const storageLimit = (allowedPermissions?.storageLimits ?? 0) + extraLimitInBytes;

        // if (auth?.userProfile?.storage + fileSize > storageLimit) {
        //   setDialogOpen(true);
        //   return;
        // }
        const timestamp = moment().valueOf().toString();
        const storage = getStorage();
        const fileRef = ref(storage, `${companyId}/reports/${timestamp}`);

        await uploadBytes(fileRef, file);
        const downloadURL = await getDownloadURL(fileRef);

        const downloadURLWithName = `${downloadURL}&name=${encodeURIComponent(fileName)}`;
        const decodedFileName = decodeURIComponent(downloadURLWithName.split('name=')[1]);

        if (Type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          setFileDownloadURL(downloadURLWithName);
        } else if (Type === 'application/pdf') {
          setPdfFileName(decodedFileName);
          setPdfFileDownloadUrl(downloadURLWithName);
        } else {
          console.error('Unknown file type:', fileName);
        }
        setAttachExcel(true);
        setAttachPdf(false);
      } catch (error) {
        console.error('Upload failed:', error);
      }
    };

    if (emailData) processFile(emailData, 'Excel');
    if (pdfData) processFile(pdfData, 'PDF');
  };

  const uploadFullData = (fullReport, fullExcelReport, fileName) => {
    const processFile = async (data, fileType) => {
      if (!data) {
        console.error(`Invalid ${fileType} data:`, data);
        return;
      }

      try {
        const contentTypeStart = data.indexOf(':') + 1;
        const contentTypeEnd = data.indexOf(';');
        const contentType = data.substring(contentTypeStart, contentTypeEnd);

        let extension = '';
        if (contentType === 'application/pdf') {
          extension = 'pdf';
        } else if (contentType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          extension = 'xlsx';
        } else if (contentType === 'text/csv') {
          extension = 'csv';
        } else {
          console.error('Unsupported file type:', contentType);
          return;
        }

        const base64DataIndex = data.indexOf('base64,') + 7;
        const base64Data = data.substring(base64DataIndex);
        const byteCharacters = atob(base64Data);
        const byteArray = new Uint8Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteArray[i] = byteCharacters.charCodeAt(i);
        }

        const blob = new Blob([byteArray], { type: contentType });
        const file = new File([blob], `${fileName}.${extension}`, { type: contentType });
        const fileSize = file.size;
        const extraLimit = auth?.userProfile?.additionalQuantity * 5;
        const extraLimitInBytes = extraLimit * (1024 ** 3);
        const storageLimit = (allowedPermissions?.storageLimits ?? 0) + extraLimitInBytes;

        // if (auth?.userProfile?.storage + fileSize > storageLimit) {
        //   setDialogOpen(true);
        //   return;
        // }
        const timestamp = moment().valueOf().toString();
        const storage = getStorage();
        const fileRef = ref(storage, `${companyId}/reports/${timestamp}`);

        await uploadBytes(fileRef, file);
        const downloadURL = await getDownloadURL(fileRef);

        const fileNameWithType = `${fileName}.${extension}`;
        const downloadURLWithName = `${downloadURL}&name=${encodeURIComponent(fileNameWithType)}`;
        const decodedFileName = decodeURIComponent(downloadURLWithName.split('name=')[1]);

        if (extension === 'xlsx') {
          setFullExcelName(decodedFileName);
          setFullReportExcelUrl(downloadURLWithName);
        } else if (extension === 'pdf') {
          setFullPdfName(decodedFileName);
          setFullReportUrl(downloadURLWithName);
        } else {
          console.error('Unknown file type:', fileNameWithType);
        }
        setAttachFullExcel(true);
        setAttachFullPdf(false);
      } catch (error) {
        console.error('Upload failed:', error);
      }
    };

    if (fullExcelReport) processFile(fullExcelReport, 'Excel');
    if (fullReport) processFile(fullReport, 'PDF');
  };


  useEffect(() => {
    if (emailData && pdfData) {
      uploadFile(emailData, pdfData, fileName);
    }
  }, [emailData, pdfData]);

  useEffect(() => {
    if (fullReport && fullExcelReport) {
      uploadFullData(fullReport, fullExcelReport, fileName);
    }
  }, [fullReport, fullExcelReport]);


  useEffect(() => {
    if (!attachExcel && !attachPdf && !attachFullPdf && !attachFullExcel) {
      setShowFormatError(true);
      return;
    }
    setShowFormatError(false);
  }, [attachExcel, attachPdf, attachFullPdf, attachFullExcel]);

  function validateEmail(emailList) {
    const emails = emailList
      .split(",")
      .map((e) => e.trim())
      .filter((e) => e !== "");

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const invalidSequenceRegex = /[\/]{1}|\.{2,}|\/\.|\.\/|[^a-zA-Z0-9._%+-@]/;

    for (let email of emails) {
      if (!emailRegex.test(email)) {
        return `Invalid format: ${email}`;
      }
      if (invalidSequenceRegex.test(email)) {
        return `Invalid characters in: ${email}`;
      }
    }

    return "";
  }


  const isFormFilled = () => {
    return (
      to.trim() !== '' &&
      subject.trim() !== '' &&
      message.trim() !== '' &&
      (attachExcel || attachPdf || attachFullPdf || attachFullExcel)
    );
  };

  const handleSendEmail = async (e) => {
    e.preventDefault();

    setLoader(true);

    const recipients = to.split(',').map(email => email.trim());
    const excelUrl = attachExcel === true ? fileDownloadURL : null;
    const pdfUrl = attachPdf === true ? pdfFileDownladUrl : null;
    const fullExcelUrl = attachFullExcel === true ? fullReportExcelUrl : null;
    const fullPdfUrl = attachFullPdf === true ? fullReportUrl : null;
    const name = `${auth?.userProfile?.firstName} ${auth?.userProfile?.lastName}`;

    try {
      const response = await sendEmailWithFiles(recipients, subject, message, excelUrl, pdfUrl, fullPdfUrl, fullExcelUrl, reportDate, FileName, name, endDate);
      if (response.success === true && response.status === 200) {
        setOpenDialog(true);
        trackEvent(CMS_EVENTS.REPORT_EMAILED, {
          report_name: ReportsName,
          recipients: to,
          date_range: `${reportDate}${endDate ? ` to ${endDate}` : ""}`
        });
        setLoader(false);
      } else {
        setOpenErrDialog(true);
        setLoader(false);
      }
    } catch (err) {
      console.error('Error sending email:', err);
      setOpenErrDialog(true);
      setLoader(false);
    }
  };

  const clearEmailStorage = () => {
    setFullReportExcelUrl(null);
    setPdfFileDownloadUrl(null);
    setFileDownloadURL(null);
    setFullReportUrl(null);
    setFullPdfName(null);
    setFullExcelName(null);
    setPdfFileName(null);
    setFileName(null);
    setTo("");
    setSubject("");
    setMessage("");
    setAttachPdf(false);
    setAttachExcel(false);
    setAttachFullExcel(false);
    setAttachFullPdf(false);
    auth?.setReportData({
      FileName: "",
      ReportsName: "",
      Name: "",
      Date: "",
      EndDate: "",
      fullData: "",
      fullExcelData: "",
      pdf: "",
      storedData: ""
    });
  };

  const handleCancel = () => {
    onClose();
    clearEmailStorage();
  };

  const handleCloseDialog = () => {
    onClose();
    clearEmailStorage();
    setOpenDialog(false);
    toast?.({
      title: "Success",
      description: "Email sent successfully",
    });
  };

  const handleCloseErrDialog = () => {
    onClose();
    clearEmailStorage();
    setOpenErrDialog(false);
    toast?.({
      title: "Error",
      description: "Error in sending email",
    });
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    clearEmailStorage();
  };

  return (
    <>
      <Dialog open={open} onOpenChange={handleCancel} fullWidth maxWidth="md">
        <DialogContent>
          <DialogTitle className="dark:text-white">Email Report</DialogTitle>
          {!(fileDownloadURL && pdfFileDownladUrl) &&
            !(fullReportUrl && fullReportExcelUrl) ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "40px",
              }}
            >
              <CircularProgress />
              <span style={{ marginLeft: 12 }} className="dark:text-white">Preparing attachments...</span>
            </div>
          ) : (
            <>
              <div>
                <div className="mb-20">
                  <Input
                    fullWidth
                    size="small"
                    name="From"
                    id="from"
                    label="From:"
                    variant="outlined"
                    value={From}
                    placeholder="From"
                    disabled
                  />
                </div>
                <div className="mb-20">
                  <Input
                    fullWidth
                    size="small"
                    name="To"
                    id="to"
                    label="To"
                    variant="outlined"
                    value={to}
                    onChange={(e) => {
                      const value = e.target.value;
                      setTo(value);
                      const errorMsg = validateEmail(value);
                      setToError(errorMsg);
                    }}
                    placeholder="To"
                    error={toError}
                    helperText={toError ? toError : ""}
                    disabled={loader}
                  />
                </div>
                <div className="mb-20">
                  <Input
                    fullWidth
                    size="small"
                    name="Subject"
                    id="subject"
                    label="Subject"
                    variant="outlined"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    placeholder="Subject"
                    disabled={loader}
                  />
                </div>
                <div className="mb-20">
                  <Textarea
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    fullWidth
                    id="description"
                    label="Add Description"
                    multiline
                    rows={4}
                    variant="outlined"
                    placeholder="Add Description"
                    disabled={loader}
                  />
                </div>
              </div>

              <div className="d-flex align-items-center mt-10">
                <div style={{ flexDirection: "column", marginTop: "-33px" }}>
                  {showFormatError && (
                    <div style={{ color: "red", marginBottom: "10px" }}>
                      Please Select At Least One Format
                    </div>
                  )}

                  <div className="flex flex-wrap gap-2 mt-15">
                    {fileName && !(fullReportUrl && fullReportExcelUrl) && (
                      <Button
                        variant={attachExcel === true ? 'default' : 'outline'}
                        size="sm"
                        onClick={() => {
                          setAttachExcel((prev) => {
                            const newValue = !prev;
                            if (newValue) {
                              setAttachFullExcel(false);
                              setAttachFullPdf(false);
                            }
                            return newValue;
                          });
                        }}
                        className="h-8 px-3 text-xs"
                      >
                        <FileSpreadsheet className="w-3 h-3 mr-4" />
                        XLSX
                      </Button>
                    )}
                    {pdfFileName && !(fullReportUrl && fullReportExcelUrl) && (
                      <Button
                        variant={attachPdf === true ? 'default' : 'outline'}
                        size="sm"
                        onClick={() => {
                          setAttachPdf((prev) => {
                            const newValue = !prev;
                            if (newValue) {
                              setAttachFullExcel(false);
                              setAttachFullPdf(false);
                            }
                            return newValue;
                          });
                        }}
                        className="h-8 px-3 text-xs"
                      >
                        <FileText className="w-3 h-3 mr-4" />
                        PDF
                      </Button>
                    )}
                    {fullPdfName && fullExcelName && (
                      <>
                        <Button
                          variant={attachFullExcel === true ? 'default' : 'outline'}
                          size="sm"
                          onClick={() => {
                            setAttachFullExcel((prev) => {
                              const newValue = !prev;
                              if (newValue) {
                                setAttachExcel(false);
                                setAttachPdf(false);
                              }
                              return newValue;
                            });
                          }}
                          className="h-8 px-3 text-xs"
                        >
                          <FileSpreadsheet className="w-3 h-3 mr-4" />
                          XLSX
                        </Button>

                        <Button
                          variant={attachFullPdf === true ? 'default' : 'outline'}
                          size="sm"
                          onClick={() => {
                            setAttachFullPdf((prev) => {
                              const newValue = !prev;
                              if (newValue) {
                                setAttachExcel(false);
                                setAttachPdf(false);
                              }
                              return newValue;
                            });
                          }}
                          className="h-8 px-3 text-xs"
                        >
                          <FileText className="w-3 h-3 mr-4" />
                          PDF
                        </Button>
                      </>
                    )}

                  </div>
                </div>
              </div>
            </>
          )}

          {(fileDownloadURL && pdfFileDownladUrl) ||
            (fullReportUrl && fullReportExcelUrl) ? (
            <div className="flex flex-col sm:flex-row gap-2 sm:justify-end pt-12 border-t">
              <Button
                type="button"
                variant="outline"
                onClick={handleCancel}
                className="h-10 text-sm"
              >
                Cancel
              </Button>
              <Button type="submit" className="h-10 text-sm" onClick={handleSendEmail}
                disabled={!isFormFilled() || showFormatError || loader}>
                {loader ? (
                  <CircularProgress size={24} style={{ color: "white" }} />
                ) : (
                  <span className="d-flex flex-center"> <Send className="w-4 h-4 mr-8" /> Send </span>
                )}
              </Button>
            </div>
          ) : null}
        </DialogContent>
      </Dialog>

      {openDialog && (
        <SuccessEmailDialog
          openDialog={openDialog}
          handleCloseDialog={handleCloseDialog}
          to={to}
          attachExcel={attachExcel}
          fileDownloadURL={fileDownloadURL}
          fileName={fileName}
          reportDate={reportDate}
          attachPdf={attachPdf}
          pdfFileDownladUrl={pdfFileDownladUrl}
          pdfFileName={pdfFileName}
          attachFullPdf={attachFullPdf}
          fullReportUrl={fullReportUrl}
          fullPdfName={fullPdfName}
          attachFullExcel={attachFullExcel}
          fullReportExcelUrl={fullReportExcelUrl}
        />
      )}

      {openErrDialog && (
        <ErrorDialog
          openErrDialog={openErrDialog}
          handleCloseErrDialog={handleCloseErrDialog}
          to={to}
        />
      )}

      {dialogOpen && (
        <StorageDialog
          dialogOpen={dialogOpen}
          handleDialogClose={handleDialogClose}
          auth={auth}
        />
      )}
    </>
  );
}

export default EmailReports;